import { round } from 'lodash';
import ColTip from '@/components/Tip';
import { renderDateTime, renderNum, renderStatusOptions } from '@/utils/common';

export const statusOptions = [
  { value: 'running', label: '进行中', status: 'Success' },
  { value: 'create', label: '创建', status: 'Processing' },
  { value: 'stop', label: '停止', status: 'Error' },
  { value: 'failed', label: '异常', status: 'Error' },
];

// Function相同的列
export const defaultColumns = [
  {
    title: '任务名称',
    sorter: true,
    fixed: 'left',
    width: 180,
  },
  {
    colKey: 'tenant',
    title: '租户',
    sorter: true,
    width: 85,
  },
  {
    colKey: 'namespace',
    title: '命名空间',
    width: 120,
    sorter: true,
  },
  {
    colKey: 'backlog',
    sorter: true,
    title: '积压条数',
    cell: renderNum,
    width: 120,
  },
  {
    colKey: 'qps',
    sorter: true,
    title: '速率',
    width: 100,
    cell: ({ row }) => `${round(row.qps, 2)}/s`,
  },
  {
    width: 120,
    sorter: true,
    title: '实例个数',
    colKey: 'instanceNum',
  },
  {
    width: 180,
    title: '启动时间',
    sorter: true,
    colKey: 'taskStartTime',
    cell: renderDateTime,
  },
  {
    title: '状态',
    colKey: 'status',
    width: 100,
    sorter: true,
    cell: renderStatusOptions,
    options: statusOptions,
  },
  {
    width: 180,
    colKey: 'updateTime',
    cell: renderDateTime,
    sorter: true,
    title: <ColTip content='非实时，有分钟级延迟'>采集时间</ColTip>,
  },
  {
    colKey: 'createByPlatform',
    sorter: true,
    title: '平台创建',
    defaultHide: true,
    cell: ({ row }) => (row.createByPlatform ? '是' : '否'),
    width: 130,
  },
  {
    colKey: 'option',
    title: '操作',
    fixed: 'right',
    align: 'center',
    width: 80,
  },
];
